<template>
  <div class="edit">
    <div class="edit__content">
      <div class="edit__content--close">
        <div @click="closeEditPlan">
          <font-awesome-icon icon="times" />
        </div>
      </div>
      <div class="edit__content--container">
        <!-- <div class="edit__content--container-image">
          <img :src="plan.logo" alt />
        </div>-->
        <div class="edit__content--container-text">Edit Plan</div>
        <div class="edit__content--container-form">
          <div class="edit__content--container-form-name">Name of Plan:</div>
          <div class="edit__content--container-form-input">
            <input v-model.trim="formData.name" type="text" class="form__input--name" />
          </div>
          <div class="edit__content--container-form-remove"></div>
        </div>
        <div class="edit__content--container-form">
          <div class="edit__content--container-form-name">Plan Price:</div>
          <div class="edit__content--container-form-input">
            <input
              v-model.trim="formData.price"
              class="form__input--worth"
              type="text"
              @keyup="formatAmount"
              placeholder="Access Plan"
            />
            <div class="form__input--naira">&#8358;</div>
          </div>
          <div class="edit__content--container-form-remove"></div>
        </div>
        <div class="edit__content--container-form">
          <div class="edit__content--container-form-name">Link to Plan Details:</div>
          <div class="edit__content--container-form-input">
            <input
              v-model.trim="formData.details"
              type="text"
              class="form__input--name"
              placeholder="www.example.com/easycare"
            />
          </div>
          <div class="edit__content--container-form-remove"></div>
        </div>

        <div>
          <div class="error">
            <div v-if="serverErrors">
              <p v-for="(value, name, index) in serverErrors" :key="index">{{value[0]}}</p>
            </div>
            <p v-if="dataSaveError">{{dataSaveError}}</p>
          </div>
        </div>

        <div class="edit__content--container-btn">
          <div @click.prevent="updatePlan()" v-show="!loading">Save Settings</div>
          <div v-show="loading">
            <WhiteLoader />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WhiteLoader from "../../partials/white-loader";
import * as types from "../../../store/constant";

export default {
  name: "EditPlans",
  props: {
    plan: {
      type: Object
    },
    hmo: {
      type: Object
    }
  },

  components: {
    WhiteLoader
  },

  data() {
    return {
      formData: {},

      serverErrors: null,
      dataSaveError: "",

      deleting: false,

      loading: false
    };
  },

  mounted() {
    this.formData = this.plan;
  },

  methods: {
    closeEditPlan() {
      this.$emit("closeEditPlan");
    },

    updatePlan() {
      this.serverErrors = null;
      this.dataSaveError = "";

      if (
        !this.formData.name ||
        !this.formData.price ||
        !this.formData.details
      ) {
        this.dataSaveError = "All the input fields are required.";
        return;
      }

      if (
        !String(this.formData.price)
          .replace(/,/g, "")
          .match(/^[0-9]+$/)
      ) {
        this.dataSaveError = "The price should be numbers only";
        return;
      }

      const formWorth = this.formData.price.replace(/,/g, "");
      this.formData.price = formWorth;
      this.formData.provider_id = this.hmo.id;

      this.loading = true;
      this.$http
        .put(`${types.CREATE_HMO_PLAN_API}/${this.plan.id}`, this.formData)
        .then(() => {
          this.loading = false;
          this.$emit("closeEditPlan", true);
        })
        .catch(err => {
          this.loading = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    },
    formatAmount() {
      if (+this.formData.price.replace(/,/g, "")) {
        this.formData.price = parseInt(
          this.formData.price.replace(/,/g, ""),
          10
        )
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        this.formData.price = this.formData.price.substring(
          0,
          this.formData.price.length - 1
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit {
  position: fixed;
  top: 0;
  left: 0;
  min-width: 1000px;
  height: 100%;
  background-color: rgba(112, 112, 112, 0.71);
  padding: 82px 13.854vw 100px 13.854vw;
  overflow: auto;

  .error {
    margin-top: 10px;
    margin-bottom: 40px;
    text-align: center;
    color: red;
    font-size: 0.938vw;
    font-style: italic;
    p {
      margin: 0;
    }
    > div {
      padding-bottom: 25px;
    }
  }

  .edit__content {
    width: 72.292vw;
    margin: 10px auto;
    border-radius: 2px;
    background-color: #ffffff;
    padding: 50px 9.74vw 50px 9.74vw;

    .edit__content--close {
      overflow: hidden;

      > div {
        width: 20px;
        height: 20px;
        float: right;
        cursor: pointer;
      }
    }

    .edit__content--container {
      margin-top: 30px;

      .edit__content--container-image {
        max-width: 10.417vw;
        margin: auto;
      }

      .edit__content--container-text {
        font-size: 1.458vw;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
        margin: 30px 0;
      }

      .edit__content--container-form {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: flex-start;
        justify-content: center;
        align-content: center;
        padding-left: 5.208vw;
        margin-bottom: 50px;

        .edit__content--container-form-name {
          width: 20%;
          font-size: 1.042vw;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.25;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }

        .edit__content--container-form-input {
          width: 60%;
          height: 40px;
          border: solid 1px #c7c7c7;
          background-color: #ffffff;
          overflow: hidden;
          position: relative;

          > .form__input--name {
            height: 40px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            border: 0;
            outline: 0;
            padding: 0 5px;
          }

          > .form__input--worth {
            height: 40px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            border: 0;
            outline: 0;
            padding: 0 5px;
            padding-left: 45px;
          }

          > .form__input--freq {
            height: 40px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            border: 0;
            outline: 0;
          }

          > .form__input--enrol {
            height: 40px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            border: 0;
            outline: 0;
          }

          > .form__input--naira {
            position: absolute;
            top: 0;
            left: 0;
            width: 40px;
            height: 40px;
            border-right: solid 1px #c7c7c7;
            background-color: #fafafa;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
          }
        }

        .edit__content--container-form-employees {
          width: 60%;
          background-color: #ffffff;
          overflow: hidden;

          > div {
            width: 50%;
            float: left;
            margin-bottom: 20px;
            padding: 0 10px;

            > div {
              height: 46px;
              border-radius: 20px;
              border: solid 1px #c7c7c7;
              background-color: #ffffff;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
              overflow: hidden;

              > .form__employees--name {
                width: 80%;
                font-size: 0.938vw;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 2.22;
                letter-spacing: normal;
                text-align: center;
                color: #5099de;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              > .form__employees--close {
                width: 20%;
                text-align: center;
                font-size: 0.938vw;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 2.22;
                letter-spacing: normal;
                color: #5099de;
                cursor: pointer;
              }
            }
          }
        }

        .edit__content--container-form-remove {
          width: 20%;
          font-size: 0.833vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: 0.54px;
          color: #f17d6b;
          text-align: center;
        }
      }

      .edit__content--container-btn {
        > div {
          width: 9.063vw;
          height: 40px;
          border-radius: 5px;
          background-color: #5099de;
          margin: auto;
          font-size: 0.781vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
